/**
 * Client for payroll's settings and an employee's pay (compensation history).
 * The runs themselves are fetched by PayrollRunsPage directly.
 */
import type { Compensation, CompensationCreate, HrSettings, HrSettingsUpdate } from '@erp/shared';
import { isAxiosError } from 'axios';

import { api } from './api.js';

export async function getHrSettings(): Promise<HrSettings> {
  return (await api().get<HrSettings>('/hr/settings')).data;
}

export async function saveHrSettings(input: HrSettingsUpdate): Promise<HrSettings> {
  return (await api().put<HrSettings>('/hr/settings', input)).data;
}

/** The pay in force today, or null when the employee has none yet (the API answers 404). */
export async function getCurrentCompensation(employeeId: string): Promise<Compensation | null> {
  try {
    return (await api().get<Compensation>(`/hr/employees/${employeeId}/compensation/current`)).data;
  } catch (err) {
    if (isAxiosError(err) && err.response?.status === 404) return null;
    throw err;
  }
}

export async function createCompensation(employeeId: string, input: CompensationCreate): Promise<Compensation> {
  return (await api().post<Compensation>(`/hr/employees/${employeeId}/compensation`, input)).data;
}
